<template>
  <div class="invoiceClip">
    <div class="wrap">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="item"
          @click="goTo(item)"
          v-for="(item, index) in data"
          :key="index"
        >
          <div>
            <div class="title">{{ item.buyerName }}</div>
            <div class="text">{{ item.createTime }}</div>
          </div>
          <div>
            <div class="title">￥{{ item.totalAmount }}</div>
          </div>
        </div>
      </van-list>
    </div>
    <div class="btnBox">
      <!-- <van-button @click="show = true"
        ><svg-icon icon-class="whiteSc" class="sc"></svg-icon
        >上传发票</van-button
      > -->
      <div v-show="uploadLoading">
        <!-- <svg-icon icon-class="wenjian"></svg-icon> -->
        <van-loading  type="spinner" class="loadingBox" size="24px" />
      </div>
      <div v-show="!uploadLoading">
        <van-uploader :after-read="afterRead" :before-read="beforeRead" multiple>
          <!-- <svg-icon icon-class="wenjian"></svg-icon> -->
          上传发票
        </van-uploader>
      </div>
    </div>
    <van-dialog
      v-model="show"
      title="上传发票"
      show-cancel-button
      :show-confirm-button="false"
    >
      <div class="uploadWrap">
        <!-- <input id="inputFile" type="file" class="hidden" multiple="multiple"/> -->
        <!-- <van-uploader :after-read="afterRead" /> -->
        <!-- <input type="file" name="file"  capture="camera"> -->
        <!-- <input type="file" accept="file/*" capture="accept" /> -->

        <div>
          <div class="top">
            <input
              type="file"
              accept="image/*"
              capture="camera"
              ref="ipt1"
              @change="fileChange($event, 'ipt1')"
            />
            <svg-icon icon-class="xiangji"></svg-icon>
          </div>
          <span class="text">拍照上传</span>
        </div>
        <div>
          <div class="top">
            <!-- <input
              type="file"
              multiple="multiple"
              ref="ipt2"
              @change="fileChange($event, 'ipt2')"
            /> -->
            <!-- <svg-icon icon-class="xiangce"></svg-icon> -->
            <van-uploader
              :after-read="afterRead"
              :before-read="beforeRead"
              multiple
            >
              <svg-icon icon-class="xiangce"></svg-icon>
            </van-uploader>
          </div>
          <span class="text">从相册上传</span>
        </div>
        <div>
          <div class="top">
            <!-- <input
              type="file"
              multiple="multiple"
              ref="ipt3"
              @change="fileChange($event, 'ipt3')"
            />
            <svg-icon icon-class="wenjian"></svg-icon> -->
            <van-uploader
              :after-read="afterRead"
              :before-read="beforeRead"
              multiple
            >
              <svg-icon icon-class="wenjian"></svg-icon>
            </van-uploader>
          </div>
          <span class="text">从文件上传</span>
        </div>
      </div>
    </van-dialog>
    <van-popup
      v-model="workflowShow"
      round
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div style="height: 100%">
        <van-picker
          title="选择工作流"
          show-toolbar
          :value-key="'workflowName'"
          :columns="workflowMask.workflowList || []"
          @confirm="onConfirm"
          @cancel="onCancel"
          @change="onChange"
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  mounted() {
    var file = document.querySelectorAll("input");
    if (getIos()) {
      file.forEach((item) => {
        item.removeAttribute("capture");
      });
    }
    function getIos() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/iPhone\sOS/i) == "iphone os") {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    this.getData();
  },
  data() {
    return {
      workflowMask:{},
      columns:[],
      showValue:"",
      workflowShow:false,
      uploadLoading:false,
      fileList: [],
      loading: false,
      finished: false,
      show: false,
      total: 0,
      data: [],
      searchForm: {
        endDate: "",
        invoiceCode: "",
        invoiceNumber: "",
        isTrue: "",
        pageNum: 1,
        pageRows: 10,
        startDate: "",
      },
    };
  },
  methods: {
    onChange(row){
      
    },
    onCancel(){
      this.workflowShow = false
    },
    onConfirm(item){
      let path = "";
      if (item.workflow == "0") {
        path = "/travelSq";
      }
      if (item.workflow == "1") {
        path = "/travelBx";
      }
      if (item.workflow == "2") {
        path = "/cityBx";
      }
      if (item.workflow == "3") {
        path = "/pettyExpenseBx";
      }
      if (item.workflow == "4") {
        path = "/excessiveApplication";
      }
      if (item.workflow == "5") {
        path = "/bx5";
      }
      if (item.workflow == "6") {
        path = "/bx6";
      }
      if (item.workflow == "7") {
        path = "/bx7";
      }
      if (item.workflow == "8") {
        path = "/bx8";
      }
      if (item.workflow == "9") {
        path = "/bx9";
      }
      if (item.workflow == "10") {
        path = "/bx10";
      }
      if (item.workflow == "11") {
        path = "/bx11";
      }
      if (item.workflow == "12") {
        path = "/bx12";
      }
      if (item.workflow == "13") {
        path = "/bx13";
      }
      this.workflowShow = false
      this.$router.push({
        path,
        query: {
          workflowName: item.workflowName,
          workflow: item.workflow,
          type: "add",
          clipList:JSON.stringify(this.workflowMask.clipList || [])
        },
      });
    },
    beforeRead(files) {
      let type = Object.prototype.toString.call(files);
      let flag = true;
      if (type.indexOf("Array") != -1) {
        files.forEach((item) => {
          let arr = item.name.split(".");
          let str = arr[arr.length - 1];
          if (
            str != "jpg" &&
            str != "jpeg" &&
            str != "png" &&
            str != "pdf" &&
            str != "zip"
          ) {
            this.$toast.fail("仅支持上传jpg,jpeg,png,pdf,zip文件");
            this.flag = false;
          }
        });
      }
      if (type.indexOf("file") != -1) {
        let arr = files.name.split(".");
        let str = arr[arr.length - 1];
        if (
          str != "jpg" &&
          str != "jpeg" &&
          str != "png" &&
          str != "pdf" &&
          str != "zip"
        ) {
          this.$toast.fail("仅支持上传jpg,jpeg,png,pdf,zip文件");
          this.flag = false;
        }
      }
      return flag;
    },
    afterRead(files) {
      let type = Object.prototype.toString.call(files);
      let params = new FormData();
      if (type.indexOf("Array") != -1) {
        files.forEach((item) => {
          params.append("file", item.file, item.file.name);
        });
      } else {
        params.append("file", files.file, files.file.name);
      }
      params.append("detailUpload", "false");
      this.uploadLoading = true
      this.$api
        .uploadPost(
          `/payment/center/invoiceClip/ocr/invoicesDiscern?token=${Cookies.get(
            "payapp_token"
          )}`,
          params
        )
        .then((res) => {
          if (res.repCode == "0000") {
            this.$notify({
              type: "success",
              message: "上传成功",
            });
            this.getData();
            this.workflowMask = res.repData
            this.columns = res.repData.workflowList || []
            this.showValue = "workflowName"
            if(res.repData.workflowList && res.repData.workflowList.length){
              this.workflowShow = true
            }
          }
          this.uploadLoading = false
        }).catch(()=>{
          this.uploadLoading = false
        })
      this.show = false;
    },
    onLoad() {
      this.searchForm.pageRows += this.searchForm.pageRows;
      this.getData();
    },
    getData() {
      this.$api
        .post("/payment/center/invoiceClip/clipList", {
          reqData: {
            ...this.searchForm,
          },
        })
        .then((res) => {
          if (res.repCode == "0000") {
            this.data = res.repData.result;
            this.total = res.repData.total;
            this.loading = false;
            if (this.total == this.data.length) {
              this.finished = true;
            }
          } else {
            this.finished = true;
          }
        })
        .catch(() => {
          this.finished = true;
        });
    },
    fileChange(ipt, ref) {
      let file = this.$refs[ref];
      let arr = file.files[0].name.split(".");
      let str = arr[arr.length - 1];
      if (
        str != "jpg" &&
        str != "jpeg" &&
        str != "png" &&
        str != "pdf" &&
        str != "zip"
      ) {
        this.$toast.fail("仅支持上传jpg,jpeg,png,pdf,zip文件");
        this.$refs[ref].value = "";
        // this.show = false;
        return;
      }
      let params = new FormData();
      params.append("file", file.files[0], file.files[0].name);
      params.append("detailUpload", "false");
      this.$api
        .uploadPost(
          `/payment/center/invoiceClip/ocr/invoicesDiscern?token=${Cookies.get(
            "payapp_token"
          )}`,
          params
          // {
          //   file:params,
          //   detailUpload :'false'
          // }
        )
        .then((res) => {
          if (res.repCode == "0000") {
            this.$notify({
              type: "success",
              message: "上传成功",
            });
            this.getData();
          }
        });
      this.$refs[ref].value = "";
      this.show = false;
    },
    goTo(row) {
      this.$router.push({
        path: "/invoiceClipDetail",
        query: row,
      });
    },
  },
};
</script>

<style lang="scss">
.invoiceClip {
  height: 100%;
  display: flex;
  flex-direction: column;
  .wrap {
    flex: 1;
    overflow-y: auto;
    padding: 0 20px;
  }
  .item {
    width: 100%;
    border-radius: 4px;
    box-shadow: 1px 2px 2px 0 #e2dada;
    background: #fff;
    padding: 16px 24px;
    margin-bottom: 10px;
    color: rgb(153, 153, 153);
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    .title {
      color: rgb(44, 44, 44);
      margin-top: 4px;
      margin-bottom: 4px;
      // font-weight: bold;
      // font-family:"Microsoft YaHei",微软雅黑,"Microsoft JhengHei",华文细黑,STHeiti,MingLiu;
    }
    .nobx {
      color: rgb(60, 119, 198);
    }
  }
  .btnBox {
    padding: 10px 20px;
    background: #fff;
    div{
      width: 100%;
      height: 40px;
      border-radius: 5px;
      background: rgb(58, 117, 197);
      font-size: 12px;
      color: #fff;
      text-align: center;
      line-height: 40px;
      input{
        height: 100%;
      }
      // .sc {
      //   font-size: 12px;
      //   margin-right: 6px;
      //   color: #fff;
      // }
    }
  }
  .van-dialog__header {
    padding-top: 0;
    padding: 10px 0;
    border-bottom: 1px solid #cfcfcf;
  }
  .uploadWrap {
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    > div {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .top {
        width: 70px;
        height: 70px;
        border: 1px solid rgb(156, 185, 221);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        margin: 20px 0;
        position: relative;
        input {
          width: 100%;
          height: 100%;
          opacity: 0;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
      .text {
        color: rgb(158, 158, 158);
        font-size: 12px;
        padding-bottom: 10px;
      }
    }
  }
}
</style>